import { render, staticRenderFns } from "./CInput.vue?vue&type=template&id=4f6d6f7c&scoped=true&"
import script from "./CInput.vue?vue&type=script&lang=ts&"
export * from "./CInput.vue?vue&type=script&lang=ts&"
import style0 from "./CInput.vue?vue&type=style&index=0&id=4f6d6f7c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6d6f7c",
  null
  
)

export default component.exports